export default __webpack_public_path__ + "static/media/bmw7-760.3e6bf670.png";